import React from 'react';
import { Mutation } from 'react-apollo';

import { mockExamStudentProfile } from '../../GraphQL/query/MockExamManage.query';
import { updateMockExamStudent } from '../../GraphQL/mutation/MockExamStudentProfile.mutation';
import Loading from '../../Components/Loading';
import { EditDataForm } from '../../Components/DataForm';

const EditProfile = ({ profile, roundCode, onSuccess }) => {
  return (
    <Mutation
      mutation={updateMockExamStudent}
      refetchQueries={[{ query: mockExamStudentProfile, variables: { roundCode } }]}
    >
      {(updateMock, { data, error }) => {
        let resultUpdateMock, resultSuccess, resultError;
        if (data) {
          resultUpdateMock = data.updateMockExamStudent || {};
          resultSuccess = resultUpdateMock.success;
          resultError = resultUpdateMock.error;
        }
        if (resultSuccess) {
          onSuccess();
          return <Loading dimmer={false} loaderProps={{ active: true, inline: 'centered' }} />;
        } else {
          return (
            <EditDataForm
              profile={profile}
              error={resultError || error}
              onSubmit={data => {
                updateMock({ variables: { roundCode, studentData: data } });
              }}
            />
          );
        }
      }}
    </Mutation>
  );
};

export default EditProfile;
